const GRADE = {
  bronze: { svg: '/static/icons/bronze.svg' },
  silver: { svg: '/static/icons/silver.svg' },
  gold: { svg: '/static/icons/gold.svg' },
  platinum: { svg: '/static/icons/diamond.svg' },
  diamond: { svg: '/static/icons/diamond.svg' },
};

export default GRADE;
